"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
var AXSIcon_1 = __importDefault(require("../../elements/AXSIcon"));
var colors_1 = require("../../constants/colors");
var lodash_1 = require("lodash");
var awesome_debounce_promise_1 = __importDefault(require("awesome-debounce-promise"));
var Select_1 = require("./Select");
var Container_1 = require("./Container");
var SearchIcon_1 = require("./SearchIcon");
var SearchField_1 = require("./SearchField");
var ClickableOptions_1 = require("./ClickableOptions");
var Options_1 = require("./Options");
var utils_1 = require("../../utils");
var CaratLoader_1 = require("./CaratLoader");
/**
 * AXSFormSelect provides single and multiple selections from a dropdown menu. It can be passed options
 * or connect to AXS API or Services API endpoints.
 */
var AXSFormSelect = /** @class */ (function (_super) {
    __extends(AXSFormSelect, _super);
    function AXSFormSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            filteredOptions: [],
            highlightedValue: -1,
            isFetching: false,
            isFocused: false,
            open: false,
            options: [],
            placeholder: '',
            response: undefined,
            searchValue: '',
            showSearchField: !!_this.props.value && _this.props.search,
            value: undefined,
        };
        _this.searchAPIDebounced = awesome_debounce_promise_1.default(function (text) {
            return fetch(_this.endpoint + encodeURIComponent(text));
        }, 500);
        /**
         * Configures the URL to the api from props passed to the component.
         *
         * @param apiConfig
         */
        _this.configureEndpoint = function (apiConfig) {
            if (apiConfig.api === 'axs') {
                var type = apiConfig.apiTypes ? "/" + apiConfig.apiTypes : '';
                return apiConfig.apiEndpoint + "/" + apiConfig.apiVersion + "/" + apiConfig.apiAction + type + "?access_token=" + apiConfig.apiToken + "&siteId=" + apiConfig.apiSites + "&v=v2&includeUnpublishedEvents=" + (apiConfig.apiIncludeUnpublishedEvents ? 'true' : 'false') + "&" + ((apiConfig.apiAction === 'autocomplete') ? 'term=' : 'q=');
            }
            if (apiConfig.api === 'services') {
                return apiConfig.apiEndpoint + "/" + apiConfig.apiVersion + "/" + apiConfig.apiAction + "?types=" + apiConfig.apiTypes + "&siteIds=" + apiConfig.apiSites + "&q=";
            }
        };
        /**
         * Handle keyboard events for controlling the component via keyboard.
         *
         * @param e
         */
        _this.handleKey = function (e) {
            var search = _this.props.search;
            var _a = _this.state, highlightedValue = _a.highlightedValue, options = _a.options, filteredOptions = _a.filteredOptions, open = _a.open;
            var componentOptions = search ? filteredOptions : options;
            if (_this.state.isFocused) {
                if (e.key === AXSFormSelect.keys.ARROW_DOWN) {
                    if (_this.searchResults.current) {
                        _this.searchResults.current.scrollTop += 50;
                    }
                    if (!open) {
                        _this.setState({ open: true });
                    }
                    else {
                        _this.setState({
                            highlightedValue: highlightedValue < componentOptions.length - 1 ? highlightedValue + 1 : 0,
                        });
                    }
                }
                if (e.key === AXSFormSelect.keys.ARROW_UP) {
                    _this.searchResults.current.scrollTop -= 50;
                    _this.setState({
                        highlightedValue: highlightedValue > 0 ? highlightedValue - 1 : componentOptions.length - 1,
                    });
                }
                if (e.key === AXSFormSelect.keys.ENTER) {
                    _this.setValue(componentOptions[highlightedValue]);
                    _this.setState({ open: false });
                }
                if (e.key === AXSFormSelect.keys.SPACE && _this.state.open) {
                    _this.setValue(componentOptions[highlightedValue]);
                }
                if (e.key === AXSFormSelect.keys.ESCAPE) {
                    _this.setState({ open: false });
                }
                if (e.key === AXSFormSelect.keys.TAB) {
                    _this.handleBlur();
                }
            }
        };
        /**
         * Handles an API Response.
         *
         * @param response
         */
        _this.handleResponse = function (response) {
            response.then(function (data) {
                _this.props.api.indexOf('services') < 0
                    ? _this.handleAXSApiResponse(data)
                    : _this.handleApiResponse(data);
            });
        };
        /**
         * Handles AXS Service API Response. See https://github.com/aegaxs/axs-services
         *
         * @param data
         */
        _this.handleApiResponse = function (data) {
            var events = data.event && data.event.matches || [];
            var performers = data.performer && data.performer.matches || [];
            var venues = data.venue && data.venue.matches || [];
            var matches = lodash_1.union(events, performers, venues);
            var selections = matches && Array.isArray(matches) && matches.map(function (option) {
                return {
                    key: option.event_id || option.performer_id || option.venue_id,
                    label: option.event_title || option.performer_title || option.venue_title,
                    value: option.event_id || option.performer_id || option.venue_id,
                };
            });
            _this.setState({
                filteredOptions: selections,
                open: true,
                options: selections,
            });
        };
        /**
         * Handles AXS API Response. See https://axsteam.atlassian.net/wiki/spaces/DPP/pages/39106903/Event+API+Documentation
         *
         * @param data
         */
        _this.handleAXSApiResponse = function (data) {
            // AXS Api returns data in a couple of different ways:
            //   - Search/Event returns an object with events array with full event object.
            //   - Autocomplete returns just an array with { label: '', value: '' }
            var selections = data && Array.isArray(data.events) ? data.events.map(function (option) {
                return {
                    key: option.eventId,
                    label: option.title.eventTitleText,
                    value: option.eventId,
                };
            }) : data.map(function (option) {
                return {
                    key: option.value,
                    label: option.label,
                    value: option.value,
                };
            });
            _this.setState({
                filteredOptions: selections,
                open: true,
                options: selections,
            });
        };
        /**
         * Sets the value when using controlled component.
         *
         * @param val
         */
        _this.setValue = function (val) {
            var _a = _this.props, handleChange = _a.handleChange, multiple = _a.multiple, value = _a.value;
            var values = Array.isArray(value) && __spreadArrays(value);
            if (multiple && Array.isArray(value)) {
                // Add or Remove
                var index = _this.checkForSelectedValue(val.value, values);
                index > -1 ? values.splice(index, 1) : values.push(val);
                _this.setState({ searchValue: val ? val.label : '' });
                handleChange(values);
            }
            else {
                _this.setState({ open: false });
                _this.setState({ searchValue: val ? val.label : '' });
                handleChange(val);
            }
        };
        /**
         * Returns the index of an array of option objects given a value to be found.
         *
         * @param value
         * @param values
         */
        _this.checkForSelectedValue = function (value, values) {
            return values && Array.isArray(values) && lodash_1.findIndex(values, { value: value });
        };
        /**
         * Filter the list of options by value of the search field.
         *
         * @param e
         */
        _this.handleSearchInput = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var filteredOptions, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (e && e.target) {
                            this.setState({ searchValue: e.target.value, showSearchField: true, open: true });
                        }
                        if (!!this.props.api) return [3 /*break*/, 1];
                        filteredOptions = this.state.options.filter(function (option) {
                            return option.label.toLowerCase().includes(e.target.value.toLowerCase());
                        });
                        this.setState({ filteredOptions: filteredOptions });
                        return [3 /*break*/, 3];
                    case 1:
                        if (!(e && e.target && e.target.value)) return [3 /*break*/, 3];
                        this.setState({ isFetching: true, highlightedValue: 0 });
                        return [4 /*yield*/, this.searchAPIDebounced(e.target.value)];
                    case 2:
                        result = _a.sent();
                        this.setState({ response: result.json(), isFetching: false });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Show the search field and focus it when the user selects the search icon.
         */
        _this.beginSearch = function () {
            _this.setState(function () {
                return { showSearchField: _this.props.search, open: !_this.state.open };
            }, function () {
                if (_this.searchField && _this.searchField.current && _this.searchField.current.focus) {
                    _this.searchField.current.focus();
                }
            });
        };
        _this.handleFocus = function () {
            _this.setState({ isFocused: true });
        };
        _this.handleBlur = function () {
            _this.setState({ isFocused: false, open: false });
        };
        _this.getSelectOptions = function () {
            var _a = _this.props, disabled = _a.disabled, iconColor = _a.iconColor, multiple = _a.multiple, options = _a.options, optionsPadding = _a.optionsPadding, search = _a.search, selectOptionsColor = _a.selectOptionsColor, selectOptionsBackgroundColor = _a.selectOptionsBackgroundColor, selectOptionsBackgroundColorHover = _a.selectOptionsBackgroundColorHover, selectOptionsSelectedBackgroundColor = _a.selectOptionsSelectedBackgroundColor, theme = _a.theme, value = _a.value, width = _a.width;
            var _b = _this.state, filteredOptions = _b.filteredOptions, highlightedValue = _b.highlightedValue;
            var availableOptions = search ? filteredOptions : options;
            var getOptionContent = function (option) {
                if (option && option.iconPosition === 'right') {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("span", null, option.label),
                        " ",
                        option.icon));
                }
                return option && (React.createElement(React.Fragment, null,
                    option.icon,
                    " ",
                    React.createElement("span", null, option.label)));
            };
            return availableOptions && availableOptions.length > 0
                ? availableOptions.map(function (option, index) {
                    var isSelected = multiple
                        ? _this.checkForSelectedValue(option.value, value) > -1
                        : _this.state.value && _this.state.value.value === option.value;
                    return (React.createElement(Options_1.Options, { key: "tag-" + option + "-" + index, isSelected: isSelected, onClick: function () { return (disabled ? undefined : _this.setValue(option)); }, highlight: highlightedValue === index, "aria-selected": isSelected, role: "option", optionsPadding: optionsPadding, selectOptionsColor: selectOptionsColor, selectOptionsBackgroundColor: selectOptionsBackgroundColor, selectOptionsBackgroundColorHover: selectOptionsBackgroundColorHover, selectOptionsSelectedBackgroundColor: selectOptionsSelectedBackgroundColor, width: width },
                        multiple && value && isSelected &&
                            React.createElement(AXSIcon_1.default, { color: utils_1.parseThemePath(iconColor, theme, colors_1.colors.BLUE_300), name: "check" }),
                        getOptionContent(option)));
                }) : React.createElement(Options_1.Options, null, "No results");
        };
        _this.handleOutsideClick = function (onClose) {
            _this.setState({ open: false });
            if (onClose) {
                onClose();
            }
            _this.handleBlur();
        };
        _this.handleSelectClick = function (api, disabled) {
            return api ? _this.beginSearch() : disabled ? undefined : _this.setState({ open: !_this.state.open });
        };
        _this.searchField = React.createRef();
        _this.searchResults = React.createRef();
        // We support two different APIs: AXS API and Services API.
        _this.endpoint = _this.configureEndpoint({
            api: _this.props.api,
            apiAction: _this.props.apiAction,
            apiEndpoint: _this.props.apiEndpoint,
            apiIncludeUnpublishedEvents: _this.props.apiIncludeUnpublishedEvents,
            apiSiteIds: _this.props.apiSiteIds,
            apiToken: _this.props.apiToken,
            apiTypes: _this.props.apiTypes,
            apiVersion: _this.props.apiVersion,
        });
        return _this;
    }
    AXSFormSelect.prototype.componentDidMount = function () {
        var _a = this.props, value = _a.value, open = _a.open, options = _a.options, placeholder = _a.placeholder;
        addEventListener('keydown', this.handleKey);
        this.setState({
            filteredOptions: options,
            open: open,
            options: options,
            placeholder: placeholder,
            value: value,
        });
    };
    AXSFormSelect.prototype.componentWillUnmount = function () {
        removeEventListener('keydown', this.handleKey);
    };
    AXSFormSelect.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, value = _a.value, open = _a.open, options = _a.options, placeholder = _a.placeholder;
        if (prevProps.value !== value) {
            this.setState({ value: value });
        }
        if (prevProps.options !== options) {
            this.setState({ filteredOptions: options, options: options });
        }
        if (prevProps.open !== open) {
            this.setState({ open: open });
        }
        if (prevProps.placeholder !== placeholder) {
            this.setState({ placeholder: placeholder });
        }
        if (prevState.response !== this.state.response) {
            this.handleResponse(this.state.response);
        }
    };
    AXSFormSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, api = _a.api, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, borderColorError = _a.borderColorError, borderColorOnFocus = _a.borderColorOnFocus, borderless = _a.borderless, caratMargin = _a.caratMargin, caratColor = _a.caratColor, color = _a.color, disabled = _a.disabled, error = _a.error, height = _a.height, inputHeight = _a.inputHeight, inputPadding = _a.inputPadding, loading = _a.loading, onClose = _a.onClose, search = _a.search, selectionPanelTopPosition = _a.selectionPanelTopPosition, selectOptionsWrapperBackgroundColor = _a.selectOptionsWrapperBackgroundColor, width = _a.width;
        var _b = this.state, showSearchField = _b.showSearchField, filteredOptions = _b.filteredOptions, options = _b.options, open = _b.open, searchValue = _b.searchValue, isFocused = _b.isFocused, isFetching = _b.isFetching, placeholder = _b.placeholder;
        var availableOptions = search ? filteredOptions : options;
        var selectedItem = this.state.value
            && availableOptions
            && availableOptions.find(function (option) { return option.value === _this.state.value.value; });
        var selectOptions = this.getSelectOptions();
        var selectionValue = search ? '' : selectedItem ? selectedItem.label : placeholder;
        var showLoader = isFetching || loading;
        return (React.createElement(react_outside_click_handler_1.default, { onOutsideClick: function () { _this.handleOutsideClick(onClose); } },
            React.createElement(Container_1.Container, __assign({ "aria-expanded": this.state.open, "aria-haspopup": "listbox", className: "c-axs-form-select", disabled: disabled, inline: true, onClick: this.handleFocus }, this.props, { height: "auto", width: width, value: this.state.value }),
                React.createElement(SearchIcon_1.SearchIcon, { className: "c-axs-form-select__menu-icon", size: "24px", color: caratColor, name: "search", onClick: !disabled && this.beginSearch, active: search ? search : api }),
                React.createElement(SearchField_1.SearchField, { borderless: true, color: color, onChange: this.handleSearchInput, onFocus: this.handleFocus, placeholder: selectedItem ? selectedItem.label : placeholder, placeholderColor: "axsui.forms.placeholder", search: search, value: searchValue, visible: showSearchField }),
                React.createElement(Select_1.Select, { border: true, borderColor: isFocused
                        ? borderColorOnFocus || 'axsui.forms.toggleBorderColorHover'
                        : error ? borderColorError
                            : borderColor, borderless: borderless, className: "c-axs-form-select__select", color: color, inputHeight: inputHeight, opacity: disabled ? '.2' : '1', inputPadding: inputPadding, search: search, backgroundColor: backgroundColor, width: width, onClick: function () { _this.handleSelectClick(api, disabled); } }, selectionValue),
                React.createElement(ClickableOptions_1.ClickableOptions, { forwardRef: this.searchResults, show: open, selectOptionsWrapperBackgroundColor: selectOptionsWrapperBackgroundColor, borderColor: borderColor, borderless: borderless, className: "c-axs-form-select__selection-panel", height: height, width: width, topPosition: selectionPanelTopPosition }, selectOptions),
                React.createElement(CaratLoader_1.CaratLoader, { caratColor: caratColor, margin: caratMargin, className: "c-axs-form-select__menu-icon", name: open ? 'keyboard-arrow-up' : 'keyboard-arrow-down', showLoader: showLoader, size: "24px" }))));
    };
    AXSFormSelect.keys = {
        ARROW_DOWN: 'ArrowDown',
        ARROW_UP: 'ArrowUp',
        ENTER: 'Enter',
        ESCAPE: 'Escape',
        SPACE: ' ',
        TAB: 'Tab',
    };
    AXSFormSelect.defaultProps = {
        api: undefined,
        apiAction: 'search',
        apiEndpoint: '',
        apiPage: 1,
        apiRows: 10,
        apiSiteIds: '1',
        apiSort: 'score',
        apiVersion: 'v1',
        backgroundColor: 'axsui.forms.backgroundColor',
        borderColor: 'axsui.forms.borderColor',
        borderColorError: 'axsui.forms.borderColorError',
        borderless: false,
        color: 'axsui.forms.color',
        disabled: false,
        handleChange: function () { return null; },
        height: 'auto',
        iconColor: 'axsui.forms.iconColor',
        loading: false,
        onBlur: function () { return null; },
        onFocus: function () { return null; },
        options: [],
        placeholder: '',
        placeholderColor: 'axsui.forms.placeholder',
        selectOptionsBackgroundColor: 'axsui.forms.selectOptionsBackgroundColor',
        selectOptionsBackgroundColorHover: 'axsui.forms.selectOptionsBackgroundColorHover',
        selectOptionsColor: 'axsui.forms.selectOptionsColor',
        selectOptionsColorHover: 'axsui.forms.selectOptionsColorHover',
        selectOptionsSelectedBackgroundColor: 'axsui.forms.selectOptionsSelectedBackgroundColor',
        selectOptionsWrapperBackgroundColor: 'axsui.forms.selectOptionsWrapperBackgroundColor',
    };
    return AXSFormSelect;
}(React.Component));
exports.default = AXSFormSelect;
//# sourceMappingURL=index.js.map